module.exports = __webpack_public_path__ + "img/si.c2844c75.svg";